import { AppBarProps } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

import { BackButtonComponent } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButtonComponent';
import { VendorLogoComponent } from '@ocx-app/components/Layout/NavigationBar/VendorLogo/VendorLogoComponent';

import { NavigationBar } from '@ocx/ui';

type ModalFullScreenHeaderProps = {
  onBackClick?(): void;
  isElevationDisabled?: boolean;
  rightSlot?: ReactElement;
  centerSlot?: ReactNode;
  position?: AppBarProps['position'];
  transparent?: boolean;
};

export const ModalFullScreenHeader = (props: ModalFullScreenHeaderProps) => {
  const { onBackClick, isElevationDisabled, rightSlot, centerSlot, position, transparent } = props;
  return (
    <NavigationBar
      isElevationDisabled={isElevationDisabled}
      position={position}
      left={onBackClick ? <BackButtonComponent onClick={onBackClick} /> : undefined}
      center={centerSlot === null ? undefined : centerSlot || <VendorLogoComponent />}
      right={rightSlot}
      color={transparent ? 'transparent' : undefined}
    />
  );
};
